import startLoading from '../actions/startLoading';
import stopLoading from '../actions/stopLoading';

export default function loadingReducer(state = [], action) {
    switch (action.type) {
        case startLoading.type:
            return state.concat([action.payload]);

        case stopLoading.type:
            return state.filter((call) => call.id !== action.payload.id);

        default:
            return state;
    }
}
